var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41416 7.99998L15.7072 1.70758C16.0979 1.31694 16.0979 0.683589 15.7072 0.29298C15.3166 -0.0976601 14.6833 -0.0976601 14.2927 0.29298L8.00022 6.58603L1.70782 0.29298C1.31718 -0.0976601 0.683833 -0.0976601 0.293224 0.29298C-0.0973847 0.68362 -0.0974159 1.31697 0.293224 1.70758L6.58628 7.99998L0.293224 14.2924C-0.0974159 14.683 -0.0974159 15.3164 0.293224 15.707C0.683865 16.0976 1.31721 16.0976 1.70782 15.707L8.00022 9.41392L14.2926 15.707C14.6833 16.0976 15.3166 16.0976 15.7072 15.707C16.0979 15.3164 16.0979 14.683 15.7072 14.2924L9.41416 7.99998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.dae9004079d0c84dd8a7d5f4ba1a79cd.svg";
export { ForwardRef as ReactComponent };